import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const WindShieldIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 126 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M125.704 62.0701L111.429 4.50423C111.083 3.11692 110.255 1.90181 109.096 1.08051C107.937 0.259208 106.525 -0.11356 105.118 0.0301909C97.2131 0.865344 75.6235 2.41634 63 2.41634C50.3765 2.41634 28.7869 0.865344 20.8825 0.0301909C19.4747 -0.11356 18.0627 0.259208 16.9041 1.08051C15.7454 1.90181 14.9173 3.11692 14.5707 4.50423L0.295601 62.0701C-0.0171832 63.263 -0.0826055 64.5083 0.103446 65.728C0.289497 66.9476 0.723 68.1151 1.37671 69.1572C2.03042 70.1992 2.8902 71.0933 3.90202 71.7831C4.91384 72.473 6.05583 72.9437 7.2562 73.1657C25.7128 75.8856 44.3493 77.162 63 76.9836C81.6507 77.162 100.287 75.8856 118.744 73.1657C119.944 72.9437 121.086 72.473 122.098 71.7831C123.11 71.0933 123.97 70.1992 124.623 69.1572C125.277 68.1151 125.711 66.9476 125.897 65.728C126.083 64.5083 126.017 63.263 125.704 62.0701Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default WindShieldIcon;

WindShieldIcon.propTypes = customIconsPropTypes;
